import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import InlineLoader from 'components/_core/InlineLoader';
import Message from 'components/_core/Message';

import { fetchCourse } from 'redux/actions';

const CourseFetcher = (
    {
        children,
        courseSlug
    }
) => {
    const dispatch = useDispatch();

    const fetched = useSelector(state => state.currentCourse.courseDetails.fetched);
    const error = useSelector(state => state.currentCourse.courseDetails.error);

    useEffect(() => {
        dispatch(fetchCourse(courseSlug));
    }, [courseSlug, dispatch]);

    if (error) {
        return (
            <Message heading="Error loading course" error noIcon small>
                Refresh the page to try again.
            </Message>
        );
    }

    if (!fetched) {
        return <InlineLoader text="Loading Course" />;
    }

    return children;
};

export default CourseFetcher;
